/**
 * This file is part of Barbacana Customizations.
 *
 * Barbacana Customizations is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * Barbacana Customizations is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * Barbacana Customizations.  If not, see <https://www.gnu.org/licenses/>.
 */
import fullpage from 'fullpage.js/dist/fullpage';

import 'fullpage.js/dist/fullpage.css';
import './view.scss';

document.querySelectorAll( '.wp-block-barbacana-full-page-slides' ).forEach( ( el ) => {
	const options = Object.assign( JSON.parse( el.dataset.options || '{}' ), {
		licenseKey: 'gplv3-license',
		sectionSelector: ':scope > div',
		credits: false,
		scrollOverflowMacStyle: true,
		afterLoad( origin, destination ) {
			document.body.classList.remove( origin.item.dataset.mode );
			document.body.classList.add( destination.item.dataset.mode );
		}
	} );

	if ( options.autoplay ) {
		options.loopBottom = ! options.continuousVertical;
		const autoplaySpeed = options.autoplaySpeed ?? 5000;

		let timeout;
		const prevAfterLoad = options.afterLoad;
		options.afterLoad = function ( ...args ) {
			prevAfterLoad( ...args );
			timeout = setTimeout( fullpage_api.moveSectionDown, autoplaySpeed );
		};
		options.onLeave = function () {
			clearTimeout( timeout );
		};
	}

	// noinspection JSPotentiallyInvalidConstructorUsage
	new fullpage( el, options );

	function moveText( e ) {
		el.style.setProperty( '--text-x', e.offsetX + 'px' );
		el.style.setProperty( '--text-y', e.offsetY + 'px' );
	}

	el.addEventListener( 'mouseover', moveText );
	el.addEventListener( 'mousemove', moveText );
} )
